import { useContext, useEffect, useState } from "react";
import { Contexto } from "@Componentes/App";
import * as _api_ from "@Funciones/api";
import * as _f_ from "@Funciones/funciones";
import * as _ipt_ from "@Elementos/Input";
import * as _btn_ from "@Elementos/Boton";
import * as _anim_ from "@Elementos/Animaciones";
import * as _tabla_ from "@Elementos/Tabla";
import * as _opt_ from "@Elementos/Opciones";
import Filtros from "@Composicion/Filtros/Filtros";
import ModalInformacion from "@ModalInformacion/ModalInformacion";
import Registro from "@ComponentesCuerpo/Registro/Registro";
import * as _testing_ from "@Funciones/testing";
import Tabla from "@ComponentesCuerpo/Tabla/Tabla";

import ListaBloques from "@ComponentesCuerpo/ListaBloques/ListaBloques";
//import "./Personal.css";

function Testing() {
  const { ecv_u } = useContext(Contexto);
  
  
  return (
    <>
    <_btn_.Boton {..._testing_.botonDatos()}/>
    
    <ListaBloques {..._testing_.listaBloques()}/>
    </>
  )
}
export default Testing;

